import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import { useBondsModalStore } from '../stores/useBondsModalStore';
import { BondsModalTypeEnum } from '../constants';

interface Props {
  title: string;
  fontSize?: string;
  color?: string;
  isCentered?: boolean;
  onClose(): void;
}

export default function ModalTitle({
  title,
  fontSize = '24px',
  color = '#333333',
  isCentered = false,
  onClose,
}: Props) {
  const modalType = useBondsModalStore((s) => s.modalType);

  const align =
    modalType === BondsModalTypeEnum.TRANSACTION ||
    modalType === BondsModalTypeEnum.ORDER ||
    modalType === BondsModalTypeEnum.CONFIRMATION ||
    isCentered
      ? 'center'
      : 'start';

  return (
    // @ts-expect-error
    <Flex justify="between" align="center" w="100%" height="50px">
      <Text
        family="bold"
        color={color}
        size={fontSize}
        align={align}
        // @ts-expect-error
        mt="0"
        width="100%"
        data-cy="bonds-modal-header"
      >
        {title}
      </Text>
      <Iconmoon
        className="icon-trading_x"
        color="#333333"
        size="12px"
        onClick={onClose}
      />
    </Flex>
  );
}
